import { BadgeOrganizationsSelection } from '../../../../../ui/features/badge-management/components/BadgeCreateWIzard/BadgeOrganizationsSelection';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
export const BadgeOrganizationsEditDialog = ({ ariaTitleId, ariaContentId, badgeOrganizationIds, onSubmit, onCancel }) => {
    const { t } = useBadgingTranslation();
    const [organizationIds, setOrganizationIds] = useState(badgeOrganizationIds !== null && badgeOrganizationIds !== void 0 ? badgeOrganizationIds : []);
    const [enableSelectionChecked, setEnableSelectionChecked] = useState(Boolean(badgeOrganizationIds === null || badgeOrganizationIds === void 0 ? void 0 : badgeOrganizationIds.length));
    const handleEnableToggle = () => {
        setEnableSelectionChecked((enabled) => {
            return !enabled;
        });
    };
    const handleSubmit = () => {
        onSubmit(enableSelectionChecked ? organizationIds : []);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { id: ariaTitleId }, t('badges.badgeList.editOrganizationsDialog.title')),
        React.createElement(DialogContent, { id: ariaContentId },
            React.createElement(BadgeOrganizationsSelection, { enableSelectionChecked: enableSelectionChecked, onEnableSelectionCheckedToggle: handleEnableToggle, organizationIdsSelected: organizationIds, onChangeOrganizationIds: setOrganizationIds })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: onCancel, "data-test": 'form-dialog-submit-button' }, t('badges.badgeList.editOrganizationsDialog.buttonCancel')),
            React.createElement(Button, { color: 'primary', onClick: handleSubmit, "data-test": 'form-dialog-submit-button' }, t('badges.badgeList.editOrganizationsDialog.buttonSubmit')))));
};
